/**
 * Password complexity validator
 *
 * Requirements:
 * - At least 8 characters
 * - At least one uppercase letter (A-Z)
 * - At least one lowercase letter (a-z)
 * - At least one digit (0-9)
 * - At least one special character (only !.-_ allowed)
 * - Only half-width alphanumeric and allowed symbols
 */

/**
 * Validate password complexity
 *
 * @param {string} password - Password to validate
 * @returns {Object} - { isValid: boolean, errors: string[] }
 */
export function validatePasswordComplexity(password) {
  const errors = [];

  // Check minimum length
  if (password.length < 8) {
    errors.push('password_min_length');
  }

  // Check for uppercase letter, lowercase letter, digit, special character, and only half-width alphanumeric and allowed symbols
  if (!/[A-Z]/.test(password)
    || !/[a-z]/.test(password)
    || !/[0-9]/.test(password)
    || !/[!.\-_]/.test(password)
    || !/^[A-Za-z0-9!.\-_]+$/.test(password)) {
    errors.push('password_invalid_characters');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
}

/**
 * Get user-friendly error message for validation error
 *
 * @param {string} errorKey - Error key from validation
 * @param {Function} t - Translation function
 * @returns {string} - Translated error message
 */
export function getPasswordErrorMessage(errorKey, t) {
  const errorMessages = {
    password_min_length: t('validation.password.minLength'),
    password_invalid_characters: t('validation.password.invalidCharacters'),
  };

  return errorMessages[errorKey] || errorKey;
}
